// Sitewide behavior
import mediumZoom from "medium-zoom";
import reframe from "reframe.js";
import isMember from "./session";
import "./infinite-scroll";
import "./gallery-card";
import "./switch-legacy";
import "../css/bristlecone.css";

// Play/pause audio
const player = (el) => {
  var audio = el.getElementsByClassName("audio")[0];
  var button = el.getElementsByClassName("media-control")[0];
  if (!audio.paused && !audio.ended) {
    audio.pause();
    button.classList.remove("pause");
    button.classList.add("play");
  } else if (audio.paused) {
    audio.play();
    button.classList.remove("play");
    button.classList.add("pause");
  }
};

// Setup modals
const setupModal = (name) => {
  const opener = `.${name}-opener`;
  if (document.getElementById(`${name}-modal`)) {
    const modal = document.getElementById(`${name}-modal`);
    const window = modal.getElementsByClassName("modal-window")[0];
    document.querySelectorAll(opener).forEach((el) => {
      el.addEventListener("click", (ev) => {
        modal.classList.remove("hidden");
        modal.addEventListener("click", (ev) => {
          modal.classList.add("hidden");
        });
        modal.querySelectorAll(".close").forEach((el) => {
          el.addEventListener("click", (ev) => {
            modal.classList.add("hidden");
          });
        });
        window.addEventListener("click", (ev) => {
          ev.stopPropagation();
          ev.stopImmediatePropagation();
        });
      });
    });
  }
};

// Config Google tag
gtag("config", "G-B8W0ZFD02Q", {
  member: Boolean(isMember),
  legacy: false,
});

const ready = (callback) => {
  if (document.readyState != "loading") callback();
  else document.addEventListener("DOMContentLoaded", callback);
};
ready(() => {
  // Look for signin links
  document.querySelectorAll(".signin-link").forEach((item) => {
    item.addEventListener("click", (event) => {
      sessionStorage.setItem("signin_action", location.pathname);
    });
  });

  if (isMember) {
    // TODO: SHOW-MEMBER WANTS TO GO AWAY
    document.querySelectorAll(".show-member").forEach((item) => {
      item.style.display = "block";
    });

    if (location.pathname == "/donate/") {
      window.location.href = "/members/";
    }

    let memberDataName = document.querySelectorAll(".memberdata-name");

    if (memberDataName) {
      memberDataName.forEach((el) => {
        if (isMember.full_name) {
          el.innerText = isMember.full_name;
        } else {
          el.innerText = isMember.username;
        }
      });
    }

    let memberDataNumber = document.querySelectorAll(".memberdata-number");

    if (memberDataNumber) {
      memberDataNumber.forEach((el) => {
        if (isMember.membership_number) {
          el.innerText = "Member " + isMember.membership_number;
        }
      });
    }

    let stripeLink = document.querySelectorAll(".stripe_link");

    if (stripeLink) {
      stripeLink.forEach((el) => {
        el.href = el.href + "&prefilled_email=" + isMember.email;
      });
    }

    let navMenuDonateButton = document.getElementById("nav-menu-donate-url");
    if (navMenuDonateButton) {
      navMenuDonateButton.href = "/members";
    }

    let donateSigninButton = document.getElementById(
      "donate-nav-signin-button"
    );

    if (donateSigninButton) {
      donateSigninButton.href = "/members/signout";
      donateSigninButton.innerText = "Sign out";
    }
  } else {
    document.querySelectorAll(".show-visitor").forEach((item) => {
      item.style.display = "block";
    });
  }

  // Toggle menu on small screens
  let navMenuButton = document.getElementById("nav-menu-button");
  if (navMenuButton) {
    navMenuButton.addEventListener("click", (event) => {
      document.querySelector("#nav-menu").classList.toggle("visible");
    });
  }

  // Hide menu after click
  document.querySelectorAll("#nav-menu A").forEach((el) => {
    el.addEventListener("click", (event) => {
      document.getElementById("nav-menu").classList.add("hidden");
    });
  });

  // Look for modal actions
  const modals = ["notice", "subscribe"];
  modals.forEach((el) => setupModal(el));

  // Setup CTA window
  const ctaPanel = document.getElementById(`cta-panel`);
  if (ctaPanel) {
    const url = new URL(window.location.href);
    if (!localStorage.getItem("cta-0202312") && url.pathname !== "/donate/") {
      ctaPanel.classList.remove("hidden");
      ctaPanel.querySelectorAll(".close").forEach((el) => {
        el.addEventListener("click", (ev) => {
          ctaPanel.classList.add("hidden");
          localStorage.setItem("cta-0202312", "hidden");
        });
      });
    }
  }

  // Add year to ideas by year lists
  const ideasYear = document.getElementById("ideas-year");
  if (ideasYear) {
    let title = window.location.pathname.substring(7, 12);
    if (title == "older") {
      title = "02003 & earlier";
    }
    ideasYear.innerHTML = title;
  }

  // Look for caption actions
  document.querySelectorAll(".captions").forEach((item) => {
    item.addEventListener("click", (event) => {
      item.classList.toggle("visible");
    });
  });

  // Click to zoom post images
  const images = [
    ...document.querySelectorAll(".kg-gallery-image > img"),
    ...document.querySelectorAll(".kg-image"),
  ];
  mediumZoom(images, {
    margin: 20,
    background: "rgba(255,255,255,0.9)",
  });

  // Reframe post videos
  reframe("iframe:not(.no-reframe)");

  // Look for player control actions
  document.querySelectorAll(".media-control").forEach((item) => {
    item.addEventListener("click", (event) => {
      player(event.target.closest(".media-player"));
    });
  });

  // Pause existing audio before starting a new one
  document.addEventListener(
    "play",
    function (e) {
      var allaudio = document.getElementsByTagName("audio");
      for (var i = 0, len = allaudio.length; i < len; i++) {
        if (allaudio[i] != e.target) {
          allaudio[i].pause();

          var button =
            allaudio[i].parentElement.getElementsByClassName(
              "media-control"
            )[0];
          button.classList.remove("pause");
          button.classList.add("play");
        }
      }
    },
    true
  );

  // Parse hashes
  const parseHash = location.hash;
  if (parseHash) {
    if (parseHash.substring(1, 7) === "donate") {
      console.log(parseHash.substring(7));
      document.getElementById("donation_amount").value = parseHash.substring(7);
    } else {
      let el = document.querySelector(parseHash);
      if (el && el.classList.contains("question")) {
        el.querySelector(".answer").classList.toggle("visible");
      }
    }
  }

  // Look for detail links
  document.querySelectorAll(".detail-link").forEach((item) => {
    item.addEventListener("click", (event) => {
      let target = item.hash.substr(1);
      document.querySelectorAll(".question").forEach((item) => {
        if (item.id === target) {
          item.querySelector(".answer").classList.toggle("visible");
        }
      });
    });
  });

  // Toggle questions
  document.querySelectorAll(".question").forEach((el) => {
    el.getElementsByTagName("p")[0].addEventListener("click", (event) => {
      el.children[1].classList.toggle("visible");
      window.location = "#" + el.id;
    });
  });

  // Copy post URL
  const copyLink = document.getElementById("copy_link");
  if (copyLink) {
    if (!navigator.clipboard) {
      copyLink.classList.add("hidden");
    } else {
      copyLink.addEventListener("click", async (e) => {
        await navigator.clipboard.writeText(copyLink.value);
      });
    }
  }
});
